module.exports = __webpack_public_path__ + "static/s-exam3-4038aa69b95248a90ece335de73b3dec.png";